<div><ngx-imageviewer [src]="src" [filetype]="filetype"></ngx-imageviewer></div>



// WEBPACK FOOTER //
// /home/runner/_work/monorepo/monorepo/admin-portal-old/src/app/core/file-viewer/file-viewer.component.html